import { render, staticRenderFns } from "./HostawayChatComponent.vue?vue&type=template&id=ca49903c&"
import script from "./HostawayChatComponent.vue?vue&type=script&lang=js&"
export * from "./HostawayChatComponent.vue?vue&type=script&lang=js&"
import style0 from "./HostawayChatComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports